import { envConfig } from "@env/env-config";

export const StateFlowRestConfig: Array<qpmn.common.rest.IServiceConfig> = [
    // 获取所有状态流转
    {
        service: "stateFlowRestService",
        funcName: "getBranch",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "api/partner/flowInstances/entity/:endityId/stateInstances/branch",
            paramDefaults: {
                endityId: "@endityId"
            }
        }
    },
    // 获取当前已完成的状态流转
    // ?includeReferenceEntity=:endityId
    {
        service: "stateFlowRestService",
        funcName: "getBranched",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "api/partner/flowInstances/entity/:endityId/stateInstances",
            paramDefaults: {
                endityId: "@endityId"
            }
        }
    },
    // 取消
    {
        service: "stateFlowRestService",
        funcName: "cancel",
        config: {
            method: "post",
            appPath: envConfig.apps.base,
            path: "api/partner/flowInstances/entity/:endityId/stateInstances",
            paramDefaults: {
                endityId: "@endityId"
            }
        }
    },
    // 提交退货申请快递信息
    {
        service: "stateFlowRestService",
        funcName: "submitExpress",
        config: {
            method: "post",
            appPath: envConfig.apps.base,
            path: "api/partner/flowInstances/entity/:endityId/stateInstances",
            paramDefaults: {
                endityId: "@endityId"
            }
        }
    },
    // 获取指定流程所有状态(退后申请)
    {
        service: "stateFlowRestService",
        funcName: "getStateNodes",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "api/stateFlows/stateNodes/latest?module=return_request_order",
        }
    },
    {
        service: "stateFlowRestService",
        funcName: "affirm",
        config: {
            method: "post",
            appPath: envConfig.apps.base,
            path: "api/partner/flowInstances/entity/:endityId/stateInstances",
            paramDefaults: {
                endityId: "@endityId"
            }
        }
    }
]

